<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'PaymentElectronicCash',
    props: {
      pt: Number,
    },
    data() {
      return {
        data: {
          // bic: null,
          iban: null,
          account_holder: null,
        },
        timer: null,
      }
    },
    computed: {
      ...mapState('payment', ['dataErrors']),
    },
    watch: {
      data: {
        handler(val) {
          this.updateData(val)
        },
        deep: true,
      },
      dataErrors(errors) {
        this.setFlags()
      },
    },
    methods: {
      ...mapActions('payment', ['updatePaymentData']),
      setFlags() {
        if (Object.keys(this.dataErrors).length) {
          // invalid
          if (this.dataErrors.account_holder) {
            this.$refs['ec-account-holder'].setFlags({
              invalid: true,
              valid: false,
            })
          }
          if (this.dataErrors.iban) {
            this.$refs['ec-iban'].setFlags({
              invalid: true,
              valid: false,
            })
          }
        } else {
          // valid
          this.$refs['ec-account-holder'].setFlags({
            invalid: false,
            valid: true,
          })
          this.$refs['ec-iban'].setFlags({
            invalid: false,
            valid: true,
          })
        }
      },
      updateData(val) {
        clearTimeout(this.timer)
        if (this.data.iban) {
          this.setFlags()
          this.timer = setTimeout(_ => {
            this.updatePaymentData({ ...val, payment: this.pt })
          }, 750)
        }
      },
    },
  }
</script>
